// extracted by mini-css-extract-plugin
export var arrow = "_2l-6";
export var changeItem = "_2l-3";
export var changesHeader = "_2l-1";
export var changesList = "_2l-2";
export var container = "_2l-0";
export var pathLabel = "_2l-4";
export var value = "_2l-7";
export var valuesContainer = "_2l-5";